/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Link } from '@doveit/lego';
import SeoLinks, { SeoLink } from '../seo-links/SeoLinks';
import * as styles from './SeoLinksGroups.style';
import { URLObject } from '../../utils/links';

export interface SeoLinksGroup {
  title: SeoLink,
  links: SeoLink[],
}

export interface SeoLinksGroupsProps {
  linkGroups: SeoLinksGroup[],
  onLinkClick?: (to: URLObject) => void,
  onTitleClick?: (to: URLObject) => void,
}

const SeoLinksGroups: React.FC<SeoLinksGroupsProps> = ({
  linkGroups,
  onTitleClick,
  onLinkClick,
}) => {
  const internalOnTitleClick = React.useCallback(
    (to) => () => {
      onTitleClick(to);
    },
    [onTitleClick],
  );

  return (
    <ul css={styles.groups}>
      {linkGroups.map((group) => (
        <li
          key={group.title.title}
          css={styles.group}
        >
          <h3
            css={styles.title}
            onClick={onTitleClick && internalOnTitleClick(group.title.to)}
          >
            {group.title.to
              ? (
                <Link
                  href={group.title.to.as}
                  css={styles.title}
                >
                  {group.title.title}
                </Link>
              ) : group.title.title}
          </h3>
          <SeoLinks
            links={group.links}
            onLinkClick={onLinkClick}
          />
        </li>
      ))}
    </ul>
  );
};

export default SeoLinksGroups;
